import axios from 'axios';

export default {
    fetchByProductId(productId) {
        return axios.get('[API]/product-attachments/by-product/' + productId, {
            responseType: 'blob',
        });
    },
    fetchByOrderId(orderId) {
        return axios.get('[API]/product-attachments/by-order/' + orderId, {
            responseType: 'blob',
        });
    },
    listByOrderId(orderId) {
        return axios.get('[API]/product-attachments/list-by-order/' + orderId);
    },
};
